function _typeof(o) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (o) {
        return typeof o;
    } : function (o) {
        return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? 'symbol' : typeof o;
    }, _typeof(o);
}
var runtime = require('../helpers/regeneratorRuntime')();
module.exports = runtime;
try {
    regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
    if ((typeof globalThis === 'undefined' ? 'undefined' : _typeof(globalThis)) === 'object') {
        globalThis.regeneratorRuntime = runtime;
    } else {
        Function('r', 'regeneratorRuntime = r')(runtime);
    }
}